import { TableCell } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export default withStyles((theme) => ({
  root: {
    border: 'none',
    padding: 5
  },
}))(TableCell);
